import { useState } from "react";

// La vista replica la estructura del PDF: mismas secciones, mismo orden.
const LONG_ANSWER_CHARS = 700;
const SECTIONS_STEP = 25;

function AnswerText({ value }) {
  const [expanded, setExpanded] = useState(false);

  if (!value) return <p className="text-sm text-gray-400">—</p>;

  const isLong = value.length > LONG_ANSWER_CHARS;
  const shown =
    isLong && !expanded ? `${value.slice(0, LONG_ANSWER_CHARS)}…` : value;

  return (
    <>
      <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
        {shown}
      </p>
      {isLong && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-0.5 text-xs font-medium text-indigo-600 hover:text-indigo-700"
        >
          {expanded ? "Ver menos" : "Ver más"}
        </button>
      )}
    </>
  );
}

function ReportSection({ section }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b-2 border-indigo-600">
        <h3 className="font-semibold text-indigo-600 break-words">
          {section.title}
        </h3>
        {section.subtitle && (
          <p className="text-xs text-gray-500 break-words">{section.subtitle}</p>
        )}
      </div>

      <div className="px-4 py-3 space-y-3">
        {section.items.length === 0 && (
          <p className="text-sm text-gray-400">Sin respuestas</p>
        )}
        {section.items.map((item) => (
          <div key={item.key}>
            <p className="text-xs font-bold text-gray-900 break-words">
              {item.label}
            </p>
            {item.context && (
              <p className="text-xs text-gray-500 italic break-words">
                {item.context}
              </p>
            )}
            <AnswerText value={item.value} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ActivityReportView({ sections, emptyMessage }) {
  const [visible, setVisible] = useState(SECTIONS_STEP);

  if (sections.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 px-4 py-8 text-center">
        <p className="text-sm text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  const shown = sections.slice(0, visible);

  return (
    <div className="space-y-3">
      {shown.map((section) => (
        <ReportSection key={section.key} section={section} />
      ))}

      {sections.length > shown.length && (
        <div className="bg-white rounded-xl border border-gray-200 px-4 py-3 text-center">
          <p className="text-xs text-gray-500 mb-2">
            Mostrando {shown.length} de {sections.length} secciones. El PDF
            incluye todas.
          </p>
          <button
            onClick={() => setVisible((prev) => prev + SECTIONS_STEP)}
            className="text-sm font-medium text-indigo-600 hover:text-indigo-700"
          >
            Mostrar más
          </button>
        </div>
      )}
    </div>
  );
}
